import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { GroupForm } from '../../app/components/forms/group';
import { trpc } from '@org/clients/school';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/groups/new')({
  component: GroupCreateRoute,
});

function GroupCreateRoute() {
  const navigate = useNavigate({ from: '/groups/new' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/groups', replace: true });
  };

  const handleSubmit = async () => {
    await utils.groups.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('groups.list.modal.createTitle')}
      size="xl"
      centered
      body={<GroupForm defaultValues={{}} onSubmit={handleSubmit} onClose={handleClose} />}
      footer={<></>}
    />
  );
}


